import { render } from "./read-list.vue?vue&type=template&id=2a07a09a&scoped=true"
import script from "./read-list.vue?vue&type=script&lang=js"
export * from "./read-list.vue?vue&type=script&lang=js"

import "./read-list.vue?vue&type=style&index=0&id=2a07a09a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a07a09a"]])

export default __exports__